<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :items="patients"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat class="toolbar-custom">
          <v-toolbar-title class="toolbar-title">
            <v-icon class="mr-2" color="#aa00ff">mdi-account-group</v-icon>
            Patients
          </v-toolbar-title>
          <v-divider class="mx-3" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <export-btn></export-btn> -->
          <!-- <v-btn
            @click="exportData"
            class="action-btn mr-2"
            large
            rounded
          >
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>New Export
          </v-btn> -->
          <v-btn
            @click="$router.go($router.currentRoute)"
            class="action-btn mr-2"
            large
            rounded
          >
            <v-icon left>mdi-refresh</v-icon>View All
          </v-btn>
          <v-btn
            @click="showFilterModal = true"
            class="action-btn-primary mr-2"
            large
            rounded
          >
            <v-icon left>mdi-filter-variant</v-icon>Filter
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="table-header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="table-header-cell"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr class="table-row">
          <!-- <td v-if="item.symptom_screening==0">
            <svg style="color:darkgray;"  xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" viewBox="0 0 24 24"><path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"/>
            </svg>
          </td>
          <td v-else>
            <svg style="color:red;"  xmlns="http://www.w3.org/2000/svg" width="1.5em" height="2em" viewBox="0 0 24 24"><path fill="currentColor" d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2"/>
            </svg>
          </td> -->
          <td>{{ page > 1 ? (page - 1) * 30 + (index + 1) : index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>
            <span v-if="item.mdrtb_reg_no">
              {{ item.mdrtb_reg_no }}
            </span>
          </td>
          <td>
            <span v-if="item.mdrtb_reg_year">
              {{ item.mdrtb_reg_year }}
            </span>
          </td>
          <td v-if="item.sex == 1">Male</td>
          <td v-else>Female</td>
          <td>{{ calculateAge(item.dob)}}</td>
          <td>
            <router-link
              v-if="item.fm_status"
              :to="`/patient-family/${item.id}`"
              class="text-primary"
            >
              M: {{ item.fm_status.male || 0 }} /
              F: {{ item.fm_status.female || 0 }}
            </router-link>

            <span v-else>--</span>
          </td>

          <td v-if="item.pre_enroll == 1">Yes</td>
          <td v-else>No</td>

          <td v-if="item.mdrtb_monopoly==1">No</td>
          <td v-else-if="item.mdrtb_monopoly==2">Yes</td>
          <td v-else-if="item.mdrtb_monopoly==3">SG</td>
          <td v-else-if="item.mdrtb_monopoly==4">MGY</td>
          <td v-else-if="item.mdrtb_monopoly==5">TGI</td>
          <td v-else>--</td>

          <td v-if="item.is_auto_nominated==true">Yes</td>
          <td v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on" v-bind="attrs"> Treatment Finished</span>
              </template>
              <span>{{ item.finished_date }}</span>
            </v-tooltip>
          </td>
          <td v-if="item.remark">{{ item.remark }}</td>
          <td v-else>--</td>
          <td>
            <span
              v-if="item.outside_tsp == 2 && formatOutsideTownshipName(item)"
            >
              {{ item.township }} ({{ formatOutsideTownshipName(item) }})
            </span>
            <span v-else>{{ item.township }}</span>
          </td>
          <td>
            <!-- <span
              :class="{
                'red accent-3': item.comments.length === 0,
                'green accent-3': item.comments.length != 0,
              }"
              class="px-3 py-1 white--text font-weight-bold"
            >
              {{ item.comments.length }}
            </span> -->
          </td>
          <td>
            <div class="action-buttons-container">
              <v-btn
                class="white--text"
                depressed
                icon
                :to="`/enroll/clu/${item.id}`"
                v-if="item.diff_finished_change >= 30"
                ><v-icon color="red darken-2"> mdi-message-text </v-icon></v-btn
              >
              <v-btn
                @click="goUpdateForm(item)"
                icon
                class="edit-btn"
                depressed
              >
                <v-icon color="white"> mdi-pencil-outline </v-icon>
              </v-btn>
              <v-btn
                v-show="!isRoleProgram"
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div class="text-center py-3 pagination-container">
      <v-pagination
        :length="pageCount"
        v-model="page"
        :total-visible="7"
        color="#aa00ff"
        class="custom-pagination"
      ></v-pagination>
    </div>
    
    <filter-box
      v-bind:dialog="showFilterModal"
      @cancel="showFilterModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Request from "@/services/Request";
import ResponseChecker from "@/services/ResponseChecker";
import ConfirmBox from "@/components/notification/ConfirmBox";
import FilterBox from "./components/FilterBox.vue";
import { CalculateAge } from "../../mixins/CalculateAge";

const outsideTownshipsUrl = "outside_township/get?";

function outsideTownshipLabelFromList(list, rawId) {
  if (rawId == null || rawId === "") return "";
  const key = String(rawId);
  const row = list.find(
    (r) =>
      String(r.id) === key ||
      (r.outside_tsp != null && String(r.outside_tsp) === key)
  );
  if (row && row.name) return row.name;
  return typeof rawId === "string" ? rawId : "";
}

export default {
  props: {
    patients: {
      type: Array,
    },
  },
  mixins: [CalculateAge],

  components: {
    ConfirmBox,
    FilterBox,
  },
  created() {
    this.syncPageFromRoute();
    this.fetchOutsideTownship();
  },
  data: () => ({
    showFilterModal: false,
    page: 1,
    itemsPerPage: 30,
    item: {},
    dialog: false,
    isUpdatingRoute: false,
    outsideTownshipsFromApi: [],
    headers: [
    //{ text: "App Refer", value: "symptom_screening" },
      { text: "No", value: "no", width: "300px", fixed: true },
      { text: "Name", value: "name", width: "300px" },
      { text: "Code", value: "code", width: "300px" },
      { text: "Year", value: "year", width: "300px" },
      { text: "Sex", value: "sex", width: "25%" },
      { text: "Age", value: "age", width: "25%" },
      { text: "Family Member", value: "fm_status" },
      { text: "Pre Enroll", value: "pre_enroll" },
      { text: "Mono-Poly", value: "monopoly" },
      { text: "Nominated", value: "Nominated" },
      { text: "Remark", value: "support_remark" },
      { text: "Township", value: "township" },
      { text: "Feedbacks", value: "comments" },

      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Patient", ["pageCount"]),
    ...mapState("Admin", ["isRoleProgram"]),
  },
  watch: {
    page(newValue) {
      // Only update route if the page actually changed and it's different from route
      const routePage = parseInt(this.$route.query.page) || 1;
      if (newValue !== routePage && !this.isUpdatingRoute) {
        this.isUpdatingRoute = true;
        const query = { ...this.$route.query };
        query.page = newValue;
        this.$router.push({ path: "/patient", query }).then(() => {
          this.$nextTick(() => {
            this.isUpdatingRoute = false;
          });
        });
      }
    },
    '$route.query.page'() {
      // Sync page from route when route changes externally (not from our own update)
      if (!this.isUpdatingRoute) {
        this.syncPageFromRoute();
      }
    },
    "$route.query.township_id"() {
      this.fetchOutsideTownship();
    },
    "$route.params.township_id"() {
      this.fetchOutsideTownship();
    },
  },
  methods: {
    currentTownshipIdForOutsideApi() {
      return (
        this.$route.query.township_id ||
        this.$route.params.township_id ||
        null
      );
    },
    async fetchOutsideTownship() {
      const tid = this.currentTownshipIdForOutsideApi();
      if (tid == null || tid === "") {
        this.outsideTownshipsFromApi = [];
        return;
      }
      const response = await Request.get_data(outsideTownshipsUrl, {
        township_id: tid,
        outside_tsp: tid,
      });
      if (!response) {
        this.outsideTownshipsFromApi = [];
        return;
      }
      const checker = new ResponseChecker(response);
      checker.checkResponse();
      if (!checker.isResponseStatusSuccess()) {
        this.outsideTownshipsFromApi = [];
        return;
      }
      const body = response.data;
      const list = Array.isArray(body) ? body : (body?.data ?? []);
      this.outsideTownshipsFromApi = Array.isArray(list) ? list : [];
    },
    formatOutsideTownshipName(item) {
      if (!item) return "";
      if (item.outside_township && item.outside_township.name) {
        return item.outside_township.name;
      }
      if (item.outside_township_name) {
        return item.outside_township_name;
      }
      const list = this.outsideTownshipsFromApi;
      let name = outsideTownshipLabelFromList(list, item.outside_tsp_name);
      if (name) return name;
      if (
        item.outside_tsp != null &&
        item.outside_tsp !== "" &&
        Number(item.outside_tsp) !== 1
      ) {
        name = outsideTownshipLabelFromList(list, item.outside_tsp);
      }
      return name || "";
    },
    syncPageFromRoute() {
      const routePage = parseInt(this.$route.query.page) || 1;
      if (this.page !== routePage) {
        this.page = routePage;
      }
    },
    exportData() {
      return this.$store.dispatch(
        "Patient/exportPatient",
        this.$route.query
      );
    },
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Patient/deletePatient", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "patient-edit",
        params: {
          id: convertNumber,
        },
      });
    },
  },
};
</script>

<style scoped>
/* Toolbar Styling */
.toolbar-custom {
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  border-bottom: 2px solid #e0e0e0;
  padding: 6px 16px;
  min-height: 70px !important;
  height: 70px !important;
}

.toolbar-title {
  font-size: 20px;
  font-weight: 600;
  color: #424242;
  display: flex;
  align-items: center;
}

/* Button Styling */
.action-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.action-btn-primary {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%) !important;
  color: white !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3);
  transition: all 0.3s ease;
}

.action-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.4);
}

/* Table Row Styling */
.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #f5f5f5 !important;
}

.table-row:nth-child(even) {
  background-color: #fafafa;
}

.table-row:nth-child(even):hover {
  background-color: #f0f0f0 !important;
}

.table-row td {
  padding: 12px !important;
  border-bottom: 1px solid #e0e0e0;
}

/* Action Buttons Container */
.action-buttons-container {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

/* Edit Button */
.edit-btn {
  background: linear-gradient(135deg, #ff6f00 0%, #e65100 100%) !important;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(255, 111, 0, 0.4);
}

/* Pagination Styling */
.pagination-container {
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.custom-pagination >>> .v-pagination__item {
  color: #aa00ff;
  font-weight: 500;
}

.custom-pagination >>> .v-pagination__item--active {
  background: #aa00ff !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3);
}

.custom-pagination >>> .v-pagination__navigation {
  color: #aa00ff;
}

.custom-pagination >>> .v-pagination__navigation:hover {
  background: rgba(170, 0, 255, 0.1);
}

/* Responsive Design */
@media (max-width: 960px) {
  .toolbar-title {
    font-size: 18px;
  }
  
  .action-btn,
  .action-btn-primary {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  .table-header-cell {
    font-size: 12px !important;
    padding: 12px 8px !important;
  }
}
</style>
